import { Button } from '@warp-ds/react/components/button';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { parseUrl } from '@/scenes/resultPage/helpers';
import styles from './TopBarMap.module.css';

type TopBarMapProps = {
    toggleFilterState: () => void;
    filtersOpen: boolean;
};

export const TopBarMap = ({ toggleFilterState, filtersOpen }: TopBarMapProps) => {
    const router = useRouter();
    const searchParams = parseUrl(router.query);

    return (
        <div className={cn(styles.topbarMap, 'flex flex-row items-center justify-between map-top-bar ph-8')}>
            <Button small href={`${router.basePath}/resultat/?${searchParams.toString()}`} data-testid="closeMapButton">
                Lukk kart
            </Button>
            <Button small onClick={toggleFilterState} data-testid="showFilterButton">
                {filtersOpen ? 'Lukk filter' : 'Vis filter'}
            </Button>
        </div>
    );
};
